import { p as promiseResolve, b as bootstrapLazy } from './index-49fd1bc4.js';

/*
 Stencil Client Patch Esm v2.17.0 | MIT Licensed | https://stenciljs.com
 */
const patchEsm = () => {
    return promiseResolve();
};

const defineCustomElements = (win, options) => {
  if (typeof window === 'undefined') return Promise.resolve();
  return patchEsm().then(() => {
  return bootstrapLazy([["preview-sk-breadcrumbs_22",[[1,"preview-sk-breadcrumbs"],[1,"preview-sk-icons"],[1,"sk-button",{"icon":[1],"iconSize":[2,"icon-size"],"size":[1],"skMode":[1,"sk-mode"],"weight":[1]}],[1,"sk-textinput",{"showLoading":[4,"show-loading"],"iconAppend":[1,"icon-append"],"iconPrepend":[1,"icon-prepend"],"placeholder":[1],"initialValue":[1,"initial-value"],"active":[32]},[[0,"focus","onFocusBlur"],[0,"blur","onFocusBlur"],[0,"keyup","onKeydown"]]],[1,"sk-badge",{"text":[1],"mode":[1],"size":[1],"weight":[1]}],[1,"sk-grid-column",{"size":[2]}],[1,"sk-grid-columns"],[1,"sk-layout-two-panel"],[1,"sk-list"],[1,"sk-list-header"],[1,"sk-list-item"],[1,"sk-list-items"],[1,"sk-page-header",{"header":[1],"subheader":[1]}],[1,"sk-panel"],[1,"sk-panel-body"],[1,"sk-panel-header",{"header":[1],"text":[1]}],[1,"sk-tab",{"text":[1],"active":[4]}],[1,"sk-tab-layout"],[1,"sk-table"],[1,"sk-table-header",{"header":[1],"text":[1]}],[1,"sk-breadcrumbs",{"items":[16],"iconSeparator":[1,"icon-separator"],"iconHome":[1,"icon-home"]}],[1,"sk-icon",{"name":[1],"size":[2],"color":[1]}]]]], options);
  });
};

export { defineCustomElements };
